import { Link } from 'gatsby';
import type { FC, ReactNode } from 'react';

const TermsLayout: FC<{ currentPage: string; children: ReactNode }> = ({
  currentPage,
  children,
}) => {
  return (
    <div className="md:flex">
      <div className="bg-gray-100 md:w-96 py-4">
        <ul className="px-6 text-sm md:block flex flex-row gap-6 overflow-x-auto">
          {[
            { Slug: 'terms-and-conditions', Title: 'Terms & Conditions' },
            {
              Slug: 'order-and-delivery-terms',
              Title: 'Order & Delivery Terms',
            },
            { Slug: 'privacy-policy', Title: 'Privacy Policy' },
          ].map(({ Slug, Title }) => {
            return (
              <li className="whitespace-nowrap" key={Slug}>
                <Link to={`/${Slug}`}>
                  <p
                    className={`
                  ${
                    currentPage.includes(Slug)
                      ? `bg-action-btn bg-clip-text 
                  text-transparent font-medium`
                      : 'font-light  hover:underline'
                  }  
                py-2`}
                  >
                    {Title}
                  </p>
                  {currentPage.includes(Slug) ? (
                    <div className="h-px bg-action-btn" />
                  ) : null}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="w-full bg-white h-full py-14 ">
        <div className="max-w-5xl mx-auto px-6">{children}</div>
      </div>
    </div>
  );
};

export default TermsLayout;
